import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';

import qrcode from '~/assets/defaults/qr-code.png';
import exclamation from '~/assets/animations/exclamation.json';

interface ITicket {
  user_id: number;
  event_id: number;
  event: string;
  slug: string;
  start_date: string;
  end_date: string;
  identifier: string;
  location: string;
  event_tab: string;
  total_quantity: string;
  available_quantity: string;
  used_quantity: string;
  canceled_quantity: string;
}

interface ITicketsGroup {
  ticket: ITicket;
}

const TicketsGroup: React.FC<ITicketsGroup> = ({ ticket }) => {
  const location = useLocation();

  const ticketPending = useMemo(() => {
    return (
      ticket.identifier !== 'Sem' &&
      ticket.event_tab === 'Proximos' &&
      parseInt(ticket.available_quantity, 10) > 0
    );
  }, [ticket.identifier, ticket.event_tab, ticket.available_quantity]);

  return (
    <div className="padding-bs">
      <Link to={`${process.env.PUBLIC_URL}${location.pathname}/${ticket.slug}`}>
        <div className="w-100 bg-ticket d-flex p-3 front mt-3">
          <div className="me-auto pe-4 pe-sm-5 align-self-center">
            <h2 className="title-h2 h6 fw-bold text-start">{ticket.event}</h2>
            <div className="d-flex">
              <div className="left-side text-start">
                <span className="d-block mb-2">Data:</span>
                <span className="d-block mb-2">Local:</span>
              </div>
              <div className="right-side text-start ps-2 ps-sm-4">
                <span className="d-block mb-2">
                  {formatInTimeZone(
                    parseISO(ticket.start_date),
                    'Europe/London',
                    'dd/MM/yyyy'
                  )}
                </span>
                <span className="d-block mb-2">{ticket.location}</span>
              </div>
            </div>
          </div>

          <div className="position-relative">
            {ticketPending && (
              <div className="h-100 w-100 position-absolute back-blur">
                <div className="anim-lottie">
                  <Lottie
                    options={{
                      animationData: exclamation,
                      autoplay: true,
                      loop: true,
                      rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                      },
                    }}
                    height={100}
                    width={100}
                  />
                  <span className="pending d-inline-block mt-2 text-white bg-danger rounded-pill px-3 py-1">
                    Pendências
                  </span>
                </div>
              </div>
            )}
            <img src={qrcode} alt="qrcode" />
            <p className="px-2 py-1 mb-0 mt-2">
              Identificador <br />#
              {ticket.user_id + ticket.event_id + 1000000000}
            </p>
          </div>

          <div className="position-relative circles">
            <div className="circle-top" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div className="small-circle" />
            <div
              className={`circle-bottom btn-circle-bottom ${
                parseInt(ticket.total_quantity, 10) > 1 ? 'white-bg' : ''
              }`}
            />
          </div>
        </div>

        {Array.from({
          length:
            parseInt(ticket.total_quantity, 10) - 1 > 2
              ? 2
              : parseInt(ticket.total_quantity, 10) - 1,
        }).map((_, index) => (
          <div className={`bg-ticket d-flex p-3 behind${index + 1}`}>
            <div className="me-auto pe-4 pe-sm-5">
              <h2 className="h6 fw-bold mb-3">Evento</h2>
              <div className="d-flex">
                <div className="left-side">
                  <span className="d-block mb-2">Data:</span>
                  <span className="d-block mb-2">Local:</span>
                  <span className="d-block">Tipo:</span>
                </div>
                <div className="right-side ps-2 ps-sm-4">
                  <span className="d-block mb-2">01/08/2023</span>
                  <span className="d-block mb-2">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit
                  </span>
                  <span className="d-block">Saída 01</span>
                </div>
              </div>
            </div>

            <div>
              <img src={qrcode} alt="qrcode" />
              <p className="px-2 py-1 mb-0 mt-2">
                Identificador <br />#
                {ticket.user_id + ticket.event_id + 1000000000}
              </p>
            </div>

            <div className="position-relative circles">
              <div className="circle-top" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div className="small-circle" />
              <div
                className={`circle-bottom ${
                  index === 0 && parseInt(ticket.total_quantity, 10) - 1 > 1
                    ? 'white-bg'
                    : ''
                }`}
              />
            </div>
          </div>
        ))}
      </Link>
    </div>
  );
};

export default TicketsGroup;
